import {
  domainConfig,
  loginPrimeHash,
  PRODUCT_XR_ACADEMY,
  PRODUCT_MOBIO_VR,
  restrictedSubDomains,
  productNameMap,
  PRODUCT_THE_VR_ACADEMY,
  PRODUCT_ACADEMIA_VR,
  PRODUCT_XR_LAB,
  PRODUCT_HK_XR_A,
  PRODUCT_VRXEDGE,
  PRODUCT_SIKLABXR,
  PRODUCT_XRLAB360,
  PRODUCT_AULAXR_MX,
  PRODUCT_AFRI_VERSE,
  PRODUCT_XR_DISCOVERY,
  PRODUCT_XR_EXPOSURE,
  PRODUCT_XR_VISION,
  PRODUCT_LAB_ACADEMY,
  PRODUCT_IMMERSI_LEARN,
  PRODUCT_XREDUCLASS,
  PRODUCT_XR_KNOWLEDGE,
  PRODUCT_ACADEMIC_LAB,
  PRODUCT_XR_STUDIOS,
  PRODUCT_MOBILNIVR,
  PRODUCT_KASOUGAKUEN,
} from "./page-constants";
import { environmentConfig } from "../../environments/environment";

export const getSubdomain = () => {
  const host = window.location.hostname;
  return host.split(".")[0];
};

export const checkIfRestrictedSubDomain = () => {
  const subdomain = getSubdomain();
  return restrictedSubDomains.includes(subdomain);
};

const getProductName = () => {
  const host = window.location.hostname;
  const domainName = host.split(".")[1];
  return productNameMap[domainName] || PRODUCT_XR_ACADEMY;
};

const getCustomerCareInfo = () => {
  const subdomain = getSubdomain();
  const showCustomerCareLink =
    subdomain === "de" ||
    subdomain === "kw" ||
    subdomain === "om" ||
    subdomain === "ae" ||
    subdomain === "nl" ||
    subdomain === "ae" ||
    subdomain === "iq" ||
    subdomain === "ps" ||
    subdomain === "bh" ||
    subdomain === "pk" ||
    subdomain === "my";
  const customerCareLink = `https://${getProductName()}.com/customer-care?subdomain=${subdomain}`;
  return { showCustomerCareLink, customerCareLink };
};
const getWhatsAppLink = () => {
  /* eslint-disable max-len */
  const subdomain = getSubdomain();
  const showWhatsAppLink = subdomain === "my";
  const whatsAppLink =
    "https://api.whatsapp.com/send/?phone=601111673277&text=Hi%2C+I+am+contacting+from+your+checksubscription+platform.+Could+you+please+help+me+with+my+subscription&type=phone_number&app_absent=0";
  return { showWhatsAppLink, whatsAppLink };
};

const getHash = (subdomain, productName, topLevelDomain) => {
  const host = `${subdomain}.${productName}.${topLevelDomain}`;
  const idx = loginPrimeHash.findIndex((item) => item.domain === host);
  return loginPrimeHash[idx] ? loginPrimeHash[idx].hash : undefined;
};
const getImpressumLink = () => {
  const subdomain = getSubdomain();
  const showImpressum = subdomain === "de";
  const impressumLink = "https://sam-media.com/impressum/";
  return { showImpressum, impressumLink };
};

const getTopLevelDomain = () => {
  const host = window.location.hostname;
  return host.split(".")[2] || "com";
};

const setVrButtonPosLeft = () => {
  const subdomain = getSubdomain();
  const host = window.location.hostname;
  const isLeftVRButton =
    subdomain === "sg" ||
    subdomain === "th" ||
    subdomain === "portal" ||
    subdomain === "my" ||
    (host.includes(PRODUCT_MOBIO_VR) && subdomain === "ae") ||
    (host.includes(PRODUCT_XR_ACADEMY) && subdomain === "ch") ||
    (host.includes(PRODUCT_ACADEMIA_VR) && subdomain === "pt") ||
    (host.includes(PRODUCT_THE_VR_ACADEMY) && subdomain === "ca");
  return isLeftVRButton;
};
export const disableQuizzSubDomains = [
  "fr",
  "cz",
  "se",
  "pl",
  "ch",
  "id",
  "de",
  "portal",
  "th",
  "my",
];

export const checkIsDisableQuizzSubDomains = () => {
  const subdomain = getSubdomain();
  return disableQuizzSubDomains.includes(subdomain);
};

export const isEnableQuizzProducts = () => {
  const enableQuizzProducts = ["vrxedge"];
  const productName = getProductName();
  return enableQuizzProducts.includes(productName);
};

const getConfigs = (subdomain, product, passedTopLevelDomain) => {
  // Default Config in case it is not found
  let config = domainConfig["demo"];
  const subdomains = Object.keys(domainConfig);
  const productName = product || getProductName();
  const topLevelDomain = passedTopLevelDomain || getTopLevelDomain();
  let hash = getHash("demo", PRODUCT_XR_ACADEMY, "com");

  if (subdomains.indexOf(subdomain) >= 0) {
    config = domainConfig[subdomain];
    const newHash = getHash(subdomain, productName, topLevelDomain);
    hash = newHash || hash;
  }

  const pageConfigs = {
    ...config,
    topLevelDomain,
    productName,
    subdomain,
    hash,
    getCustomerCareInfo,
    getWhatsAppLink,
    setVrButtonPosLeft,
    getImpressumLink,
  };
  return pageConfigs;
};

export let config = {};

if (window.domainConfig && window.domainConfig.origin) {
  const [subdomain, domain, topLevelDomain] =
    window.domainConfig.origin.split(".");
  config = getConfigs(subdomain, domain, topLevelDomain);
} else if (
  getSubdomain() === "localhost" ||
  environmentConfig.production === false
) {
  // set here for localhost
  config = getConfigs("jp", PRODUCT_KASOUGAKUEN, "com");
} else {
  config = getConfigs(getSubdomain());
}

export const getCategoryFromUrl = () => {
  const url = window.location.href;
  const category = url.split("/")[3].split("?")[0];
  return category;
};
